import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Home from '@/pages/Home';
import ComingSoon from '@/pages/ComingSoon';
import Speakers from '@/pages/Speakers';
import SpeakerDetail from '@/pages/SpeakerDetail';
import Gallery from '@/pages/Gallery';
import PartnerWall from '@/pages/PartnerWall';
import AdminApp from '@/admin/AdminApp';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experiences" element={<ComingSoon routeKey="experiences" title="All Experiences" />} />
          <Route path="/fast-track" element={<ComingSoon routeKey="fast-track" title="Fast Track" />} />
          <Route path="/speakers" element={<Speakers />} />
          <Route path="/speakers/:slug" element={<SpeakerDetail />} />
          <Route path="/partners" element={<PartnerWall />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/privacy" element={<ComingSoon routeKey="privacy" title="Privacy Policy" />} />
          <Route path="/terms" element={<ComingSoon routeKey="terms" title="Terms" />} />
          <Route path="/faq" element={<ComingSoon routeKey="faq" title="FAQ" />} />
          <Route path="/contact" element={<ComingSoon routeKey="contact" title="Contact" />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
